import axios from '../utils/axios';

export default function fetchFollowUp(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/company-follow-up', { params })
    )
}
